export class AcceptRejectBusinessCase{
    processId:number;
    processTempReqRelId:number;
    comment:string;
    userId:number;
    amount:number;
    userMail:string;
    templateTypeName:string;
    partyName:string;
}